import { render, staticRenderFns } from "./EmailTemplates.vue?vue&type=template&id=f8329694&scoped=true&"
import script from "./EmailTemplates.vue?vue&type=script&lang=ts&"
export * from "./EmailTemplates.vue?vue&type=script&lang=ts&"
import style0 from "../../assets/css/helpdesk/email-templates.css?vue&type=style&index=0&id=f8329694&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8329694",
  null
  
)

export default component.exports